import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TheSachet from "./components/TheSachet";
import Cocoa from "./components/Cocoa";
import OneOrder from "./components/OneOrder";
import Formats from "./components/Formats";
import HowWeSupply from "./components/HowWeSupply";
import ExportDetail from "./components/ExportDetail";
import SpecialtyCoffee from "./components/SpecialtyCoffee";
import Faq from "./components/Faq";
import SampleForm from "./components/SampleForm";
import Footer from "./components/Footer";

export default function CoffeeHospitality() {
  useEffect(() => {
    document.title =
      "Organic Cane Sugar Sachets & Cocoa for Cafés and Hotels | Mesa Baja";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Certified organic unrefined cane sugar sachets and cocoa powder from Colombia for coffee chains, hotels and foodservice. Ecocert USDA and EU Organic. Request samples."
      );
    }
  }, []);

  return (
    <main className="min-h-screen bg-cream">
      <Header />
      <Hero />
      <TheSachet />
      <Cocoa />
      <OneOrder />
      <Formats />
      <HowWeSupply />
      <ExportDetail />
      <SpecialtyCoffee />
      <Faq />
      <SampleForm />
      <Footer />
    </main>
  );
}